export const environment = {
    production: false,
    staging: false,
    baseUrl: 'https://gcmsbackend.dmqifs.site/api',
    storageServer: 'https://gcmsstorage.dmqifs.site/api'
  };